module.exports = __webpack_public_path__ + "static/media/saved_boatyard_marker.855da9ff.svg";